import React, { useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';

import RatingStars from '../../../rating-stars';

import { hideModal } from '../../../../actions/modal';
import Textarea from '../../../input-controls/textarea';
import { rateViewer } from '../../../../actions/rating';
import Snackbar from '../../../snackbar';
import Spacer from '../../../spacer';

import Modal from '../..';
import Buttons from '../../buttons';
import { Content, ModalBodyContainer } from '../../components';

export const SnackbarContainer = styled.span`
    display: flex;
    margin-bottom: calc(var(--space-unit) * 2);

    @media (min-width: 768px) {
        margin-bottom: calc(var(--space-unit) * 4);
    }
`;

export const QuestionsContainer = styled.span`
    display: flex;
    flex-direction: column;
`;

export const Question = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: calc(var(--space-unit) * 3);

    @media (min-width: 768px) {
        flex-direction: row;
    }
`;

export const RatingModalBody = ({ onClose, rateViewer }) => {
    const [firstRating, setFirstRating] = useState(0);
    const [secondRating, setSecondRating] = useState(0);
    const [value, setValue] = useState('');
    const [sent, setSent] = useState(false);

    const sendRating = () => {
        rateViewer(firstRating, secondRating, value.trim());
        setSent(true);
    };

    return (
        <Modal title="Ci aiuti a migliorare?" subtitle="Lasciaci il tuo parere" onClose={onClose}>
            <ModalBodyContainer hasSubtitle={true}>
                <Content>
                    {sent && (
                        <SnackbarContainer>
                            <Snackbar type="success" message="Ricevuto! Grazie per il tuo tempo" />
                        </SnackbarContainer>
                    )}
                    <QuestionsContainer>
                        <Question>
                            <span className="body-3">{"Capire come passare da un esercizio all'altro è stato facile?"}</span>
                            <RatingStars
                                disabled={sent}
                                onChange={(value) => {
                                    setFirstRating(value);
                                }}
                            />
                        </Question>
                        <Question>
                            <span className="body-3">{'Capire cosa fare per svolgere gli esercizi è stato facile?'}</span>
                            <RatingStars
                                disabled={sent}
                                onChange={(value) => {
                                    setSecondRating(value);
                                }}
                            />
                        </Question>
                    </QuestionsContainer>
                    <Spacer size="base" />
                    <span className="body-3">{"Hai qualcos'altro da dire? Scrivici"}</span>
                    <Spacer size="base" />
                    <Textarea onChange={(e) => setValue(e.target.value)} value={value} placeholder="Il tuo messaggio" disabled={sent} />
                </Content>
                <Buttons
                    showPrimaryButton={!sent}
                    primaryButtonClick={() => sendRating()}
                    primaryButtonDisabled={!value.trim() || !firstRating || !secondRating}
                    primaryButtonText="Invia"
                    showTertiaryButton={!sent ? true : isMobile ? true : false}
                    tertiaryButtonClick={onClose}
                    tertiaryButtonText={sent ? 'Chiudi' : 'Non ora'}
                />
            </ModalBodyContainer>
        </Modal>
    );
};

RatingModalBody.propTypes = {
    onClose: PropTypes.func,
    rateViewer: PropTypes.func,
};

const actionsCreator = {
    onClose: hideModal,
    rateViewer: rateViewer,
};

export default connect(null, actionsCreator)(RatingModalBody);
